import React from "react";

const clients = [
  { name: "Central de Maderas", img: "/img/clientes/central-de-maderas.webp" },
  { name: "Colbeef", img: "/img/clientes/colbeff.png" },
  { name: "Colbúfalos", img: "/img/clientes/colbufalos.png" },
  { name: "Gavassa", img: "/img/clientes/gavassa.gif" },
  { name: "Líneas Hospitalarias", img: "/img/clientes/lineas-hospitalarias.jpeg" },
  { name: "Kikes", img: "/img/clientes/logo-kikes.webp" },
  { name: "Meco E.U.", img: "/img/clientes/meco-eu.jpg" },
  { name: "Salsan", img: "/img/clientes/salsan.png" },
  { name: "Satélite Global", img: "/img/clientes/satelite-global.jpg" },
  { name: "Transejes", img: "/img/clientes/transejes.png" },
];

export default function ClientLogos() {
  return (
    <section
      id="clientes"
      data-testid="clients-section"
      className="relative py-24 lg:py-32 bg-[#12141a] border-y border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="mb-16">
          <div className="text-[11px] uppercase tracking-[0.3em] text-[#ff6b00] mb-4 flex items-center gap-3">
            <span className="w-8 h-px bg-[#ff6b00]" />
            <span>Confianza</span>
          </div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tighter max-w-3xl">
            Empresas que confían en nuestro trabajo.
          </h2>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-px bg-white/5 border border-white/5">
          {clients.map((c) => (
            <div
              key={c.name}
              data-testid={`client-logo-${c.name.toLowerCase().replace(/\s+/g, "-")}`}
              className="group bg-white p-6 lg:p-8 flex items-center justify-center h-28"
            >
              <img
                src={c.img}
                alt={c.name}
                className="max-h-10 lg:max-h-12 w-auto object-contain grayscale opacity-70 group-hover:grayscale-0 group-hover:opacity-100 transition-all duration-500"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
